export const RECEIVE_IMPORT_CONTEXT = 'RECEIVE_IMPORT_CONTEXT';
export const PRE_BULK_IMPORT_PRODUCTS = 'PRE_BULK_IMPORT_PRODUCTS';
export const RECEIVE_CATALOG_IMPORT_RESULT = 'RECEIVE_CATALOG_IMPORT_RESULT';
